import Vue from "vue";
import Vuex from "vuex";
import persistedState from "vuex-persistedstate";

Vue.use(Vuex);
const state = {
  wxUserInfo: null,
  userInfo: {},
  role: -1,
  province: "",
  addressInfos: {}, // 位置信息
  userAccessToken: {}, // 用于获取用户信息的token
  jsSDKAccessToken: {}, // 用于获取js调用权限的token
  jsTicket: {}, // 获取签名的票据
  openid: null,
  signature: null
};
const getters = {
  getWxUserInfo(state) {
    return state.wxUserInfo;
  },
  getWxSignature(state) {
    return state.signature;
  },
  getUserInfo(state) {
    return state.userInfo;
  },
  getRole(state) {
    return state.role;
  },
  getProvince(state) {
    return state.province;
  },
  getUserType(state) {
    const role = state.role;
    switch (role) {
      case 0:
        return 1;
      case 1:
        return 3;
      case 2:
        return 4;
      case 3:
        return 5;
      default:
        return -1;
    }
  }
};
const mutations = {
  SET_WX_SIGNATURE: (state, data) => {
    const d = data || {};
    state.signature = d;
  },
  SET_WX_USERINFO: (state, data) => {
    const d = data || {};
    state.wxUserInfo = d;
  },
  SET_WX_TICKET: (state, t) => {
    const d = t || {};
    state.jsTicket = d;
  },
  SET_USER_ACCESS_TOKEN: (state, t) => {
    const d = t || {};
    state.userAccessToken = d;
  },
  SET_USER_LOCATION: (state, t) => {
    const d = t || {};
    state.addressInfos = d;
  },
  SET_JSSDK_ACCESS_TOKEN: (state, t) => {
    const d = t || {};
    state.jsSDKAccessToken = d;
  },
  SET_OPENID: (state, t) => {
    const d = t || "";
    state.openid = d;
  },
  SET_USERINFO: (state, data) => {
    const d = data || {};
    state.userInfo = d;
  },
  SET_ROLE: (state, data) => {
    const d = data || 0;
    state.role = d;
  },
  SET_PROVINCE: (state, data) => {
    const d = data || "";
    state.province = d;
  }
};
const actions = {
  setWxSignature: ({ commit }, data) => {
    commit("SET_WX_SIGNATURE", data);
  },
  setWxUserInfo: ({ commit }, data) => {
    commit("SET_WX_USERINFO", data);
  },
  setUserAccessToken: ({ commit }, data) => {
    commit("SET_USER_ACCESS_TOKEN", data);
  },
  setUserInfo: ({ commit }, data) => {
    commit("SET_USERINFO", data);
  },
  setRole: ({ commit }, data) => {
    commit("SET_ROLE", data);
  },
  setProvince: ({ commit }, data) => {
    commit("SET_PROVINCE", data);
  }
};
export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {},
  plugins: [persistedState()]
  // plugins: [
  //   persistedState({
  //     storage: window.sessionStorage,
  //     reducer(val) {
  //       return {
  //         role: val.role
  //       };
  //     }
  //   }),
  //   persistedState({
  //     storage: window.localStorage,
  //     reducer(val) {
  //       return {
  //         wxUserInfo: val.wxUserInfo,
  //         userInfo: val.userInfo,
  //         province: val.province,
  //         addressInfos: val.addressInfos,
  //         userAccessToken: val.userAccessToken,
  //         jsSDKAccessToken: val.jsSDKAccessToken,
  //         jsTicket: val.jsTicket,
  //         openid: val.openid,
  //         signature: val.signature
  //       };
  //     }
  //   })
  // ]
});
